import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, AppBar, Toolbar, IconButton, Typography, TextField, CircularProgress } from '@material-ui/core'
import { show, update, store, change, success as changeSuccess } from '../../../store/actions/prizes.action'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { changeAlert } from '../../../store/actions/alert.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import MaskedInput from 'react-text-mask'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'int') {
        mask = [/[0-9]/, /\d/]
    }

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/]
    }

    if (props.name === 'def') {
        mask = [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
    }

    if (props.name === 'perc') {
        mask = [/[0-9]/, '.', /\d/, /\d/, /\d/]

        if (other.value) {
            let valid = other.value.replace('.', '')
            if (valid.length > 3) {
                mask = [/[0-9]/, /\d/, '.', /\d/, /\d/]
            }
        }
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

export default function PrizeEdit(props) {
    const dispatch = useDispatch()
    const { prize, error } = useSelector(state => state.prizesReducer)
    const campaign_id = (props.campaign_id) ? props.campaign_id : null
    const id = (props.uid) ? props.uid : null;

    const [qtd, setQtd] = React.useState(1)
    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        _index()
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(() => setLoading(false))
        } else {
            dispatch(change('clear'))
            setLoading(false)
        }
    }

    const _save = () => {
        if(id) {
            dispatch(update({
                'id' : id,
                'campaign_id' : campaign_id,
                'title' : prize.title,
                'percent' : document.getElementById('percent') ? document.getElementById('percent').value : null,
                'min_amount' : document.getElementById('min_amount') ? document.getElementById('min_amount').value : null,
                'max_amount' : document.getElementById('max_amount') ? document.getElementById('max_amount').value : null
            }))
        } else {
            dispatch(store({
                'qtd' : qtd,
                'campaign_id' : campaign_id,
                'title' : prize.title,
                'percent' : prize.percent,
                'min_amount' : document.getElementById('min_amount') ? document.getElementById('min_amount').value : null,
                'max_amount' : document.getElementById('max_amount') ? document.getElementById('max_amount').value : null
            }))
        }
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Prêmio' : 'Novo Prêmio'}
                    </Typography>

                    <Button 
                        variant="contained" 
                        size="small"
                        onClick={() => _save()}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaSave />}
                    >
                        Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-2 bs-bg">
                        <div className="mb-3">
                            <label className="label-custom d-block bs-color">Quantidade</label>
                            <TextField
                                name="qtd"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: qtd,
                                    placeholder: '1',
                                    onChange: e => setQtd(e.target.value ? parseInt(e.target.value) : e.target.value)
                                }}
                            />
                        </div>

                        <div className="mb-5">
                            <label className="label-custom bs-color-b">Prêmio</label>
                            <TextField
                                error={(error.title) && true}
                                value={prize.title || ''}
                                placeholder="Ex: R$ 300"
                                onChange={text => dispatch(change({ title: text.target.value }))}
                            />
                        </div>

                        {(qtd === 1) &&
                            <div className="mb-3">
                                <label className="label-custom bs-color-b">Porcentagem</label>
                                <TextField
                                    id="percent"
                                    name="perc"
                                    type="tel"
                                    InputProps={{
                                        inputComponent: TextMaskCustom,
                                        value: prize.percent > 0 ? prize.percent : '',
                                        placeholder: 'ex: 70',
                                        onChange: text => {
                                            if(text.target.value.length === 2) {
                                                if(text.target.value > 99) {
                                                    dispatch(changeAlert({
                                                        open: true,
                                                        msg: 'Limite maximo até 99% da campanha',
                                                        class: 'error'
                                                    }))
                                                    dispatch(change({ percent: 99 }))
                                                }
                                            } else {
                                                dispatch(change({ percent: text.target.value }))
                                            }
                                        },
                                        onBlur: text => dispatch(change({ percent: text.target.value }))
                                    }}
                                />
                            </div>
                        }

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Valor Minimo</label>
                            <TextField
                                id="min_amount"
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: prize.min_amount > 0 ? Number(prize.min_amount) : '',
                                    placeholder: 'ex: 20',
                                    onChange: text => {
                                        if(text.target.value > 50) {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Limite maximo até 50 reais',
                                                class: 'error'
                                            }))
                                            dispatch(change({ min_amount: '' }))
                                        } else {
                                            dispatch(change({ 
                                                min_amount: text.target.value,
                                                max_amount: null
                                            }))
                                        }
                                    }
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="label-custom bs-color-b">Valor Máximo</label>
                            <TextField
                                id="max_amount"
                                name="int"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: prize.max_amount > 0 ? Number(prize.max_amount) : '',
                                    placeholder: 'ex: 20',
                                    onChange: text => {
                                        if(text.target.value > 50) {
                                            dispatch(changeAlert({
                                                open: true,
                                                msg: 'Limite maximo até 50 reais',
                                                class: 'error'
                                            }))
                                            dispatch(change({ max_amount: '' }))
                                        } else {
                                            dispatch(change({ 
                                                min_amount: null,
                                                max_amount: text.target.value 
                                            }))
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                </>
            }
            </div>
        </>
    )
}
